import { Typography, Box, useTheme } from "@mui/material";
import React from "react";

const Header = ({ title, subtitle }) => {
  const theme = useTheme();
  return (
    <Box>
      <Box
        sx={{
          width: "2.5rem",
          height: "4px",
          borderRadius: "999px",
          backgroundColor: theme.palette.secondary.main,
          mb: "0.9rem",
        }}
      />
      <Typography
        variant="h2"
        color={theme.palette.text.primary}
        sx={{ mb: "0.4rem" }}
      >
        {title}
      </Typography>
      {subtitle && (
        <Typography variant="h5" fontWeight={400} color={theme.palette.text.secondary}>
          {subtitle}
        </Typography>
      )}
    </Box>
  );
};

export default Header;
